/** Structural guard for error-shaped values carrying a non-empty `code`, like our API error bodies. */
export function isErrorWithCode(error: unknown): error is { code: string } {
  return (
    error !== undefined &&
    error !== null &&
    typeof error === 'object' &&
    'code' in error &&
    typeof error.code === 'string' &&
    error.code !== ''
  );
}
